import { debounce } from 'lodash'

/* ---------------------------------------------------- */
/* Undo Changes                                         */
/* ---------------------------------------------------- */
const afterUndoRedo = () => {

	// Update draggable after undo
	var elx = window.Stylist.iBodyJQ.find(".stlst-selected");
	if ( elx.length > 0 ) {

		if ( elx.css("position") == 'static' ) {
			elx.css("position","relative");
			window.Stylist.iBodyJQ.find(".stlst-selected-others").css("position","relative");
		}

	}

	window.Stylist.updateHistory();

	// Update breakpoints if responsive mode
	if ( window.stlst_legacy.is_responsive_mod() ) {
		window.stlst_legacy.updateResponsiveBreakpoints();
	}

}

const debounceAfterUndoRedo = debounce( afterUndoRedo, 500 )

export default function undoRedo( action ) {
	if ( 'undo' !== action && 'redo' !== action ) {
		return false
	}

	if ( window.stlst_legacy.is_resizing() ||
			window.stlst_legacy.is_visual_editing() ||
			window.stlst_legacy.is_dragging() ||
			window.Stylist.mainBody.hasClass( "stlst-processing-now" ) ) {
		return false;
	}

	window.Stylist.codeEditor.execCommand( action )

	// Run afterUndoRedo() functions only once with delay.
	debounceAfterUndoRedo()
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/undo-redo.js